module.exports = __webpack_public_path__ + "767e54b.woff2";